import React, { useState } from 'react';
import './Header.css';
import logo from '../assets/images/logo.png';

function Header() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="header">
      <img alt="Logo" src={logo} className="logo" id="header-logo" />
      <div className="menu-icon" onClick={() => setIsOpen(!isOpen)}>
      ☰
      </div>
      <nav className={`nav-links ${isOpen ? 'open' : ''}`}>
        <a href="https://www.supremepizzaonline.ca/" className="header-link">Home</a>
        <a href="https://www.supremepizzaonline.ca/menu.html" className="header-link">Menu</a>
        <a href="https://www.supremepizzaonline.ca/about.html" className="header-link">About Us</a>
        <a href="https://www.supremepizzaonline.ca/franchise.html" className="header-link">Franchise</a>
      </nav>
    </header>
  );
}

export default Header;